import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';


class ReportPurchasingModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#reportPurchasingModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const { ShowPDFViewerModal, TypeDoc,
            ListReports, ShowPDFViewer, ReportsModel,
            ActualDate, GetPurchasingDocs, MailTools,
            ChangeInitialDate, ChangeFinalDate, ChangeSupplierEntries, ChangeSupplierInvoices,
            ChangeSupplierReturns, ChangeSupplierCreditNotes, ChangeType, CleanReportModel, CloseReportPurchasingModal,
            sucursales, ShowFormatToPrint, printhide,
            ChangeSucursal,
        } = this.props;

        return (
            <div className="modal fade" id="reportPurchasingModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportPurchasingModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Reporte de Compras</h5>
                            <button type="button"
                                className="close"
                                onClick={() => { CleanReportModel(); CloseReportPurchasingModal() }}
                                style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">

                                <div className='row'>

                                    <div className='col-12 col-md-5'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde: </strong></span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel && ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                                onKeyDown={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        GetPurchasingDocs()
                                                    }
                                                }}


                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-5'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta: </strong></span>
                                            </div>
                                            <input
                                                type="date"
                                                className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel && ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                                onKeyDown={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        GetPurchasingDocs()
                                                    }
                                                }}

                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-2'>
                                        {/* <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Condición crédito:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Type}
                                                onChange={event => ChangeType(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                <option value="contado">Contado</option>
                                                <option value="credito">Crédito</option>
                                                <option value="ambos">Ambos</option>
                                            </select>
                                        </div> */}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-md-8'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Sucursal:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Sucursal}
                                                onChange={event => ChangeSucursal(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!sucursales && sucursales.map(sucursal => {
                                                    return (
                                                        <option value={sucursal.code}>{`${sucursal.nombre}`}</option>
                                                    )
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12 mt-3 font-weight-bold'> Tipos de operación: </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="checkEntries"
                                                        checked={ReportsModel.supplierEntries}
                                                        onClick={ChangeSupplierEntries} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="checkEntries"> Entradas de proveedor </label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="BillsEmployee"
                                                        checked={ReportsModel.supplierInvoices}
                                                        onClick={ChangeSupplierInvoices} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="BillsEmployee"> Facturas de proveedor </label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="ReturnEmployee"
                                                        checked={ReportsModel.supplierReturns}
                                                        onClick={ChangeSupplierReturns} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="ReturnEmployee"> Devoluciones de proveedor </label>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <div className="form-check input-group-text">
                                                    <input
                                                        type="checkbox"
                                                        id="flexCheckDefault"
                                                        checked={ReportsModel.supplierCreditNotes}
                                                        onClick={ChangeSupplierCreditNotes} />
                                                </div>
                                            </div>
                                            <label className="form-control" htmlFor="flexCheckDefault"> Notas de credito de proveedor </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                                className="btn btn-secondary"
                                onClick={() => { CleanReportModel(); CloseReportPurchasingModal() }}
                                data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GetPurchasingDocs()}>Generar</button>
                        </div>
                    </div>
                </div>

                <PdfViewer
                    DocsToPrint={ListReports}
                    TypeDoc={TypeDoc}
                    EnableEditButton={false}
                    Editable={false}
                    ChangeEditableMode={false}
                    EditableDocModel={'SalesTools.EditableDocModel'}
                    RefreshDocModel={'SalesTools.RefreshDocModel'}
                    SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                    UploadDoc={'SalesTools.UploadInvoice'}
                    EditParam1={false}
                    ShowPDFViewer={() => { ShowPDFViewer(); CleanReportModel(); }}
                    user={'user'}
                    Counter={true}
                    ReportsModel={ReportsModel}
                    MailTools={MailTools}
                    printhide={printhide}
                    ShowFormatToPrint={ShowFormatToPrint}
                    reprint={false}
                />

            </div>
        );
    }
}

export default ReportPurchasingModal;